import type { LngLat } from '@yandex/ymaps3-types';
import { type Nullable } from '@direct-frontend/stdlib';

const POSITION_COEFFICIENT = 0.3;

type VerticalPosition = 'top' | 'bottom';
type HorizontalPosition = 'left' | 'right';
type MenuPosition = `${VerticalPosition} ${HorizontalPosition}`;

export function getMenuPosition(
    coordinates: LngLat,
    bounds: Nullable<[LngLat, LngLat]>,
    center: Nullable<Readonly<LngLat>>
): MenuPosition {
    if (!bounds || !center) {
        return 'bottom right';
    }

    const x = Math.abs(bounds[0][0] - bounds[1][0]) / 2;
    const y = Math.abs(bounds[0][1] - bounds[1][1]) / 2;

    const xPoint = coordinates[0] - center[0];
    const yPoint = coordinates[1] - center[1];

    const xCoef = xPoint / x;
    const yCoef = yPoint / y;

    const xPosition = xCoef < POSITION_COEFFICIENT || xCoef < -POSITION_COEFFICIENT ? 'right' : 'left';
    const yPosition = yCoef > POSITION_COEFFICIENT || yCoef > -POSITION_COEFFICIENT ? 'bottom' : 'top';

    return `${yPosition} ${xPosition}`;
}
